import { render, staticRenderFns } from "./DonutChart66.vue?vue&type=template&id=f99b3592&scoped=true"
import script from "./DonutChart66.vue?vue&type=script&lang=js"
export * from "./DonutChart66.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99b3592",
  null
  
)

export default component.exports